export const ORDER_TYPE = {
  MARKET: 'market',
  LIMIT: 'limit',
  LIMIT_UP: 'limitUP',
  STOP: 'stop',
};

export const ORDER_SIDE_CLOSE = {
  BUY: 'BUY',
  SELL: 'SELL',
};

export const ORDER_SIDE = {
  LONG: 'LONG',
  SHORT: 'SHORT',
};
